(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[4914,9057,958],{

/***/ 81445:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/facturacion",
      function () {
        return __webpack_require__(99863);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 99863:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSP": function() { return /* binding */ __N_SSP; },
  "default": function() { return /* binding */ facturacion; }
});

// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(70865);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(96670);
// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(66383);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/use-media/lib/index.js
var lib = __webpack_require__(81145);
// EXTERNAL MODULE: ../../node_modules/lodash/get.js
var get = __webpack_require__(72579);
var get_default = /*#__PURE__*/__webpack_require__.n(get);
// EXTERNAL MODULE: ../../node_modules/date-fns/esm/parseISO/index.js + 1 modules
var parseISO = __webpack_require__(85488);
// EXTERNAL MODULE: ../../node_modules/date-fns/esm/format/index.js + 31 modules
var format = __webpack_require__(5027);
// EXTERNAL MODULE: ../../packages/commerce/src/APIClient.ts + 1 modules
var APIClient = __webpack_require__(33125);
// EXTERNAL MODULE: ../../packages/commerce/src/utils/error.js
var error = __webpack_require__(38102);
// EXTERNAL MODULE: ../../packages/commerce/src/StoreClient.ts
var StoreClient = __webpack_require__(52177);
// EXTERNAL MODULE: ../../packages/commerce/src/index.ts + 2 modules
var src = __webpack_require__(25144);
// EXTERNAL MODULE: ../../packages/commerce/src/CommerceProvider.tsx + 15 modules
var CommerceProvider = __webpack_require__(82148);
// EXTERNAL MODULE: ../../node_modules/prop-types/index.js
var prop_types = __webpack_require__(13980);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);
// EXTERNAL MODULE: ../../node_modules/@headlessui/react/dist/components/transitions/transition.js + 3 modules
var transition = __webpack_require__(68810);
// EXTERNAL MODULE: ../../packages/icons/solid/esm/BillNoteIcon.js
var BillNoteIcon = __webpack_require__(5519);
// EXTERNAL MODULE: ../../packages/designkit/src/components/webkit/atoms/SwitchButton/index.js + 1 modules
var SwitchButton = __webpack_require__(61739);
// EXTERNAL MODULE: ../../packages/icons/solid/esm/InformationIcon.js
var InformationIcon = __webpack_require__(81906);
// EXTERNAL MODULE: ../../packages/designkit/src/components/webkit/molecules/Tooltip/Tooltip.jsx
var Tooltip = __webpack_require__(38534);
// EXTERNAL MODULE: ../../packages/designkit/src/assets/invoice-order-tooltip.svg
var invoice_order_tooltip = __webpack_require__(12965);
var invoice_order_tooltip_default = /*#__PURE__*/__webpack_require__.n(invoice_order_tooltip);
// EXTERNAL MODULE: ../../packages/designkit/src/assets/invoice-ticket-tooltip.svg
var invoice_ticket_tooltip = __webpack_require__(64246);
var invoice_ticket_tooltip_default = /*#__PURE__*/__webpack_require__.n(invoice_ticket_tooltip);
;// CONCATENATED MODULE: ../../packages/designkit/src/components/webkit/molecules/FormInvoiceInstructions/FormInvoiceInstructions.jsx






var FormInvoiceInstructions = function(param) {
    var context = param.context, isDesktop = param.isDesktop;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "flex gap-x-2 bg-brand-primary-100 py-5 px-2 md:gap-0",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "row-span-full block w-max md:hidden",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            children: "\uD83D\uDC40"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex w-full flex-col gap-x-2 md:flex-row md:items-center",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "flex w-full md:w-max",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    className: "m-0 flex w-full flex-col md:flex-row md:gap-x-1 md:text-sm",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("strong", {
                                        className: "flex gap-x-1",
                                        children: [
                                            "\xbfY d\xf3nde est\xe1 eso, t\xfa?",
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                className: "hidden md:flex",
                                                children: "\uD83D\uDC40"
                                            })
                                        ]
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "flex w-2/3 items-center justify-start text-start md:w-max",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        className: "flex font-body text-xs md:w-full md:text-sm",
                                        children: context === "online" ? "Ntp, encu\xe9ntralos en tu correo de confirmaci\xf3n de compra \uD83D\uDC49" : "Ntp, encu\xe9ntralos ac\xe1 \uD83D\uDC49"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Tooltip/* default */.Z, {
                                        uniqueId: "ticket-information",
                                        placement: isDesktop ? "right" : "bottom",
                                        anchorClassName: "lg:ml-2 flex",
                                        tooltipBgColor: "bg-brand-primary-100",
                                        arrowFillColor: "fill-brand-primary-100",
                                        tooltipContent: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                            src: context === "online" ? (invoice_order_tooltip_default()) : (invoice_ticket_tooltip_default()),
                                            alt: "Ticket information"
                                        }),
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(InformationIcon/* default */.Z, {
                                            className: "flex w-6"
                                        })
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                className: "text-start font-body-bold",
                children: "Buscar ".concat(context === "online" ? "Pedido" : "Ticket")
            })
        ]
    });
};
FormInvoiceInstructions.defaultProps = {
    context: "online"
};
FormInvoiceInstructions.propTypes = {
    context: prop_types_default().oneOf([
        "online",
        "offline",
        null
    ]),
    isDesktop: (prop_types_default()).bool
};
/* harmony default export */ var FormInvoiceInstructions_FormInvoiceInstructions = (FormInvoiceInstructions);

;// CONCATENATED MODULE: ../../packages/designkit/src/components/webkit/molecules/FormInvoiceInstructions/index.js


// EXTERNAL MODULE: ../../node_modules/date-fns/esm/addMonths/index.js
var addMonths = __webpack_require__(28187);
// EXTERNAL MODULE: ../../node_modules/classnames/index.js
var classnames = __webpack_require__(72779);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ../../packages/designkit/src/components/webkit/atoms/Input/index.js
var Input = __webpack_require__(17529);
// EXTERNAL MODULE: ../../packages/designkit/src/components/webkit/atoms/Button/index.js + 1 modules
var Button = __webpack_require__(62772);
;// CONCATENATED MODULE: ../../packages/designkit/src/components/webkit/molecules/FormInvoiceTicket/FormInvoiceTicket.jsx








var FormInvoiceTicket = function(param) {
    var className = param.className, isLoading = param.isLoading, ticketValues = param.ticketValues, ticketStatus = param.ticketStatus, setTicketValues = param.setTicketValues, handleConsultTicket = param.handleConsultTicket, handleResetValues = param.handleResetValues, children = param.children;
    var minDate = (0,format/* default */.Z)((0,addMonths/* default */.Z)(new Date(), -1), "yyyy-MM-dd");
    var maxDate = (0,format/* default */.Z)(new Date(), "yyyy-MM-dd");
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("form", {
        onSubmit: function(e) {
            return handleConsultTicket(e);
        },
        className: classnames_default()(className, "grid w-full grid-cols-2 gap-4"),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Input/* default */.Z, {
                id: "store-Id",
                name: "store id",
                className: "col-span-2 lg:col-span-1",
                label: "Sucursal",
                type: "number",
                placeholder: "728",
                value: ticketValues.storeId,
                onChange: function(e) {
                    return setTicketValues((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, ticketValues), {
                        storeId: e
                    }));
                },
                required: true
            }, "storeId"),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Input/* default */.Z, {
                id: "ticket-number",
                name: "ticket number",
                className: "col-span-2 lg:col-span-1",
                label: "Num. Ticket",
                type: "number",
                placeholder: "123",
                value: ticketValues.ticketId,
                onChange: function(e) {
                    return setTicketValues((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, ticketValues), {
                        ticketId: e
                    }));
                },
                required: true
            }, "ticketNumber"),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Input/* default */.Z, {
                id: "register",
                name: "register",
                className: "col-span-2 lg:col-span-1",
                label: "Caja",
                type: "number",
                placeholder: "03",
                value: ticketValues.posId,
                onChange: function(e) {
                    return setTicketValues((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, ticketValues), {
                        posId: e
                    }));
                },
                required: true
            }, "register"),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Input/* default */.Z, {
                id: "date-of-bill",
                name: "date of bill",
                className: "col-span-2 cursor-pointer lg:col-span-1",
                label: "Fecha de compra",
                type: "date",
                placeholder: "14-05-2023",
                value: ticketValues.ticketDate,
                onChange: function(e) {
                    return setTicketValues((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, ticketValues), {
                        ticketDate: e
                    }));
                },
                inputProps: {
                    min: minDate,
                    max: maxDate
                },
                required: true
            }, "dateOfBill"),
            children && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "col-span-2 lg:order-last",
                children: children
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "col-span-2 my-6 flex flex-col justify-center gap-y-4 lg:flex-row lg:gap-x-10",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                        type: "button",
                        variants: "secondary",
                        size: "md",
                        disabled: isLoading,
                        onClick: function() {
                            return handleResetValues("ticket");
                        },
                        children: "Limpiar"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                        type: "submit",
                        size: "md",
                        loading: isLoading,
                        disabled: Object.values(ticketValues).some(function(v) {
                            return v === "";
                        }),
                        children: ticketStatus && (ticketStatus === null || ticketStatus === void 0 ? void 0 : ticketStatus.ticketFound) && (ticketStatus === null || ticketStatus === void 0 ? void 0 : ticketStatus.canRequest) ? "Continuar" : "Consultar ticket"
                    })
                ]
            })
        ]
    });
};
FormInvoiceTicket.propTypes = {
    className: prop_types.string,
    isLoading: prop_types.bool,
    ticketStatus: prop_types.object,
    handleConsultTicket: prop_types.func,
    handleResetValues: prop_types.func,
    children: prop_types.node
};
/* harmony default export */ var FormInvoiceTicket_FormInvoiceTicket = (FormInvoiceTicket);

;// CONCATENATED MODULE: ../../packages/designkit/src/components/webkit/molecules/FormInvoiceTicket/index.js


;// CONCATENATED MODULE: ../../packages/designkit/src/components/webkit/molecules/FormFindOrderInvoice/FormFindOrderInvoice.jsx







var FormFindOrderInvoice = function(param) {
    var className = param.className, isLoading = param.isLoading, handleConsultOrder = param.handleConsultOrder, orderResult = param.orderResult, orderValues = param.orderValues, setOrderValues = param.setOrderValues, handleResetValues = param.handleResetValues, children = param.children;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("form", {
        onSubmit: function(e) {
            return handleConsultOrder(e);
        },
        className: classnames_default()(className, "grid w-full grid-cols-2 gap-4"),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Input/* default */.Z, {
                id: "order-number",
                name: "orderNumber",
                className: "col-span-2 lg:col-span-1",
                label: "# Pedido",
                type: "number",
                placeholder: "2222553501",
                value: orderValues.publicId,
                onChange: function(e) {
                    return setOrderValues((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, orderValues), {
                        publicId: e
                    }));
                },
                required: true
            }, "orderNumber"),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Input/* default */.Z, {
                id: "totalAmount",
                name: "total",
                className: "col-span-2 lg:col-span-1",
                label: "Total",
                type: "number",
                placeholder: "$000.00",
                value: orderValues.total,
                onChange: function(e) {
                    return setOrderValues((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, orderValues), {
                        total: e
                    }));
                },
                required: true
            }, "total"),
            children && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "col-span-2 lg:order-last",
                children: children
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "col-span-2 my-6 flex flex-col justify-center gap-y-4 lg:flex-row lg:gap-x-10",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                        type: "button",
                        variants: "secondary",
                        size: "md",
                        disabled: isLoading,
                        onClick: function() {
                            return handleResetValues("order");
                        },
                        children: "Limpiar"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                        type: "submit",
                        size: "md",
                        loading: isLoading,
                        disabled: Object.values(orderValues).some(function(v) {
                            return v === "";
                        }),
                        children: orderResult && (orderResult === null || orderResult === void 0 ? void 0 : orderResult.found) && (orderResult === null || orderResult === void 0 ? void 0 : orderResult.canRequest) ? "Continuar" : "Consultar pedido"
                    })
                ]
            })
        ]
    });
};
FormFindOrderInvoice.propTypes = {
    className: prop_types.string,
    isLoading: prop_types.bool,
    orderResult: prop_types.object,
    orderValues: prop_types.object,
    setOrderValues: prop_types.func,
    handleConsultOrder: prop_types.func,
    handleResetValues: prop_types.func,
    children: prop_types.node
};
/* harmony default export */ var FormFindOrderInvoice_FormFindOrderInvoice = (FormFindOrderInvoice);

// EXTERNAL MODULE: ../../packages/designkit/src/components/webkit/molecules/Alert/index.js + 1 modules
var Alert = __webpack_require__(2921);
// EXTERNAL MODULE: ../../packages/designkit/src/components/webkit/layouts/Section/index.js + 1 modules
var Section = __webpack_require__(46350);
;// CONCATENATED MODULE: ../../packages/designkit/src/components/webkit/organisms/InvoiceRequest/InvoiceRequest.jsx











var getErrorMessage = function(err) {
    var errorMessage;
    switch(err){
        case "Esta factura ya fue solicitada":
            errorMessage = "Lo sentimos, s\xf3lo se puede generar una factura por pedido. \xc9chale un ojo a tu bandeja de entrada en tu correo, casi seguro que ya est\xe1 por all\xe1 \uD83D\uDE4F.";
            break;
        case "Error para generaci\xf3n de factura":
            errorMessage = "Lo sentimos, solo tienes 30 d\xedas naturales para solicitar tu factura \uD83D\uDE14";
            break;
        case "Ticket no localizado":
            errorMessage = "\xa1Ups! Algo sali\xf3 mal, checa los datos de tu ticket y vuelve a ingresarlos \uD83D\uDE2C ";
            break;
        case "Pedido no localizado":
            errorMessage = "\xa1Ups! Algo sali\xf3 mal, checa los datos de tu pedido y vuelve a ingresarlos \uD83D\uDE2C ";
            break;
        default:
            return;
    }
    return errorMessage;
};
var PurchaseOffline = function(param) {
    var className = param.className, ticketValues = param.ticketValues, ticketStatus = param.ticketStatus, setTicketValues = param.setTicketValues, isLoading = param.isLoading, isDesktop = param.isDesktop, handleConsultTicket = param.handleConsultTicket, handleResetValues = param.handleResetValues;
    var ticketId = ticketStatus.ticketId, ticketFound = ticketStatus.ticketFound, ticketTotalSale = ticketStatus.ticketTotalSale, message = ticketStatus.message, canRequest = ticketStatus.canRequest, isInitialState = ticketStatus.isInitialState;
    var foundAndCanRequest = ticketFound && canRequest;
    var errorMessage = getErrorMessage(message);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: className,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(FormInvoiceInstructions_FormInvoiceInstructions, {
                context: "offline",
                isDesktop: isDesktop
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(FormInvoiceTicket_FormInvoiceTicket, {
                isLoading: isLoading,
                isDesktop: isDesktop,
                ticketValues: ticketValues,
                ticketStatus: ticketStatus,
                setTicketValues: setTicketValues,
                handleConsultTicket: handleConsultTicket,
                handleResetValues: handleResetValues,
                children: !isLoading && ticketStatus && !isInitialState && /*#__PURE__*/ (0,jsx_runtime.jsx)(Alert/* default */.Z, {
                    icon: foundAndCanRequest && /*#__PURE__*/ (0,jsx_runtime.jsx)(BillNoteIcon/* default */.Z, {
                        className: "mr-2 flex w-6 self-start"
                    }),
                    className: "order-2 py-1 md:order-last",
                    variant: foundAndCanRequest ? "informative" : "error",
                    title: message,
                    children: foundAndCanRequest ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                        className: "my-0 ml-8 grid grid-cols-2 text-start",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                className: "col-span-2 lg:col-span-1",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                                        children: "Num Ticket: "
                                    }),
                                    ticketId
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                className: "col-span-2 lg:col-span-1",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                                        children: "Total:"
                                    }),
                                    " $",
                                    ticketTotalSale
                                ]
                            })
                        ]
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: "ml-8 flex text-start",
                        children: errorMessage
                    })
                })
            })
        ]
    });
};
var PurchaseOnline = function(param) {
    var className = param.className, isLoading = param.isLoading, orderStatus = param.orderStatus, orderValues = param.orderValues, setOrderValues = param.setOrderValues, isDesktop = param.isDesktop, handleConsultOrder = param.handleConsultOrder, handleResetValues = param.handleResetValues;
    var found = orderStatus.found, canRequest = orderStatus.canRequest, message = orderStatus.message, date = orderStatus.date, total = orderStatus.total, isInitialState = orderStatus.isInitialState;
    var foundAndCanRequest = found && canRequest;
    var errorMessage = getErrorMessage(message);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: className,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(FormInvoiceInstructions_FormInvoiceInstructions, {
                context: "online",
                isDesktop: isDesktop
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(FormFindOrderInvoice_FormFindOrderInvoice, {
                isLoading: isLoading,
                isDesktop: isDesktop,
                orderValues: orderValues,
                orderResult: orderStatus,
                setOrderValues: setOrderValues,
                handleConsultOrder: handleConsultOrder,
                handleResetValues: handleResetValues,
                children: !isLoading && orderStatus && !isInitialState && /*#__PURE__*/ (0,jsx_runtime.jsx)(Alert/* default */.Z, {
                    icon: foundAndCanRequest && /*#__PURE__*/ (0,jsx_runtime.jsx)(BillNoteIcon/* default */.Z, {
                        className: "mr-2 flex w-6 self-start"
                    }),
                    className: "order-first py-1 md:order-last",
                    variant: foundAndCanRequest ? "informative" : "error",
                    title: message,
                    children: foundAndCanRequest ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                        className: "my-0 ml-8 grid grid-cols-2 text-start",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                className: "col-span-2 lg:col-span-1",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                                        children: "Fecha de compra: "
                                    }),
                                    date
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                className: "col-span-2 lg:col-span-1",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                                        children: "Total:"
                                    }),
                                    " $",
                                    total
                                ]
                            })
                        ]
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: "ml-8 flex text-start",
                        children: errorMessage
                    })
                })
            })
        ]
    });
};
var InvoiceRequest = function(param) {
    var isDesktop = param.isDesktop, isLoading = param.isLoading, ticketStatus = param.ticketStatus, orderStatus = param.orderStatus, orderValues = param.orderValues, ticketValues = param.ticketValues, setOrderValues = param.setOrderValues, setTicketValues = param.setTicketValues, handleConsultTicket = param.handleConsultTicket, handleConsultOrder = param.handleConsultOrder, handleResetValues = param.handleResetValues;
    var ref = (0,react.useState)(false), isOnline = ref[0], setIsOnline = ref[1];
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Section/* default */.Z, {
        className: "bg-brand-tertiary-100 text-center",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "container max-w-3xl",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                    className: "lg:mb-12",
                    children: "Facturaci\xf3n Yema \uD83D\uDCC4"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("h3", {
                    className: "lg:mb-4",
                    children: [
                        "\xa1Hola! gracias por comprar en Yema, ",
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                        "\xbfnecesitas una factura?"
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                    className: "lg:mb-15",
                    children: "Selecciona tu tipo de compra:"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(SwitchButton/* default */.Z, {
                    onClick: function() {
                        return setIsOnline(!isOnline);
                    },
                    enabled: isOnline,
                    labelOn: "Compra en tienda",
                    labelOff: "Compra online"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(transition/* Transition */.u, {
                    className: "inline-block w-full",
                    enter: "transform transition ease-in-out duration-300",
                    enterFrom: "-translate-x-full opacity-0",
                    enterTo: "translate-x-0 opacity-100",
                    leave: "transform transition ease-in-out duration-300",
                    leaveFrom: "opacity-100",
                    leaveTo: "opacity-0 absolute top-4 hidden",
                    show: isOnline,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(PurchaseOnline, {
                        className: "mt-8 lg:mt-12",
                        isDesktop: isDesktop,
                        isLoading: isLoading,
                        orderStatus: orderStatus,
                        orderValues: orderValues,
                        setOrderValues: setOrderValues,
                        handleConsultOrder: handleConsultOrder,
                        handleResetValues: handleResetValues
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(transition/* Transition */.u, {
                    className: "inline-block w-full",
                    enter: "transform transition ease-in-out duration-300",
                    enterFrom: "-translate-x-full opacity-0",
                    enterTo: "translate-x-0 opacity-100",
                    leave: "transform transition ease-in-out duration-300",
                    leaveFrom: "opacity-100",
                    leaveTo: "opacity-0 absolute top-4 hidden",
                    show: !isOnline,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(PurchaseOffline, {
                        className: "mt-8 lg:mt-12",
                        ticketValues: ticketValues,
                        ticketStatus: ticketStatus,
                        setTicketValues: setTicketValues,
                        isLoading: isLoading,
                        isDesktop: isDesktop,
                        handleConsultTicket: handleConsultTicket,
                        handleResetValues: handleResetValues
                    })
                })
            ]
        })
    });
};
InvoiceRequest.propTypes = {
    isDesktop: (prop_types_default()).bool,
    isLoading: (prop_types_default()).bool,
    handleConsultTicket: (prop_types_default()).func,
    handleConsultOrder: (prop_types_default()).func,
    ticketStatus: (prop_types_default()).object,
    orderStatus: (prop_types_default()).object,
    ticketValues: (prop_types_default()).object,
    orderValues: (prop_types_default()).object,
    setTicketValues: (prop_types_default()).func,
    setOrderValues: (prop_types_default()).func,
    handleResetValues: (prop_types_default()).func
};
/* harmony default export */ var InvoiceRequest_InvoiceRequest = (InvoiceRequest);

;// CONCATENATED MODULE: ../../packages/designkit/src/components/webkit/organisms/InvoiceRequest/index.js


// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(92228);
// EXTERNAL MODULE: ../../node_modules/graphql-tag/lib/index.js + 10 modules
var graphql_tag_lib = __webpack_require__(60138);
;// CONCATENATED MODULE: ../../packages/commerce/src/graphql/queries/invoice/t3b-tickets.gql.js

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    query T3B_TICKET($ticketId: String!, $storeId: String!, $posId: String!, $ticketDate: Date!) {\n        t3bTicket(ticketId: $ticketId, storeId: $storeId, posId: $posId, ticketDate: $ticketDate) {\n            ticketId\n            ticketFound\n            ticketTotalSale\n            canRequest\n            message\n        }\n    }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}

var QUERY_T3B_TICKET = (0,graphql_tag_lib/* gql */.Ps)(_templateObject());
/* harmony default export */ var t3b_tickets_gql = (QUERY_T3B_TICKET);

;// CONCATENATED MODULE: ../../packages/commerce/src/graphql/queries/invoice/order-for-invoice.gql.js

function order_for_invoice_gql_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    query OrderForInvoice($publicId: ID!, $total: Float!) {\n        orderForInvoice(publicId: $publicId, total: $total) {\n            date\n            found\n            message\n            canRequest\n            total\n        }\n    }\n"
    ]);
    order_for_invoice_gql_templateObject = function _templateObject() {
        return data;
    };
    return data;
}

var ORDER_FOR_INVOICE = (0,graphql_tag_lib/* gql */.Ps)(order_for_invoice_gql_templateObject());
/* harmony default export */ var order_for_invoice_gql = (ORDER_FOR_INVOICE);

// EXTERNAL MODULE: ../../packages/commerce/src/graphql/queries/user/me-basic.gql.js
var me_basic_gql = __webpack_require__(21960);
;// CONCATENATED MODULE: ./components/invoice/InvoicePage.js

















var INITIAL_TICKET_STATE = {
    isInitialState: true,
    ticketId: "",
    ticketFound: false,
    ticketTotalSale: "",
    message: "",
    canRequest: null
};
var INITIAL_TICKET_VALUES = {
    posId: "",
    storeId: "",
    ticketId: "",
    ticketDate: ""
};
var INITIAL_ORDER_STATE = {
    isInitialState: true,
    total: "",
    date: "",
    found: false,
    message: "",
    canRequest: null,
    publicId: ""
};
var INITIAL_ORDER_VALUES = {
    publicId: "",
    total: ""
};
var InvoicePage = function() {
    var isMobile = (0,lib/* default */.ZP)({
        maxWidth: 640
    });
    var userIsLogged = (0,StoreClient/* useSelector */.v)(function(param) {
        var authentication = param.authentication;
        return authentication.token !== null;
    });
    var ref = (0,_sliced_to_array/* default */.Z)((0,src/* useStateEngine */.kG)(), 2), _ = ref[0], dispatch = ref[1];
    var ref1 = (0,react.useState)(INITIAL_TICKET_STATE), ticketResult = ref1[0], setTicketResult = ref1[1];
    var ref2 = (0,react.useState)(INITIAL_ORDER_STATE), orderResult = ref2[0], setOrderResult = ref2[1];
    var ref3 = (0,react.useState)(INITIAL_ORDER_VALUES), orderValues = ref3[0], setOrderValues = ref3[1];
    var ref4 = (0,react.useState)(INITIAL_TICKET_VALUES), ticketValues = ref4[0], setTicketValues = ref4[1];
    var ref5 = (0,APIClient/* useQuery */.aM)(me_basic_gql/* default */.Z, {
        ssr: false,
        skip: !userIsLogged,
        fetchPolicy: "cache-first"
    }), dataMeBasic = ref5.data;
    var ref6 = (0,_sliced_to_array/* default */.Z)((0,APIClient/* useLazyQuery */.td)(t3b_tickets_gql, {
        fetchPolicy: "network-only"
    }), 2), getTicket = ref6[0], ref7 = ref6[1], loadingTicket = ref7.loading, ticketError = ref7.error;
    var ref8 = (0,_sliced_to_array/* default */.Z)((0,APIClient/* useLazyQuery */.td)(order_for_invoice_gql, {
        fetchPolicy: "network-only"
    }), 2), getOrder = ref8[0], ref9 = ref8[1], loadingOrder = ref9.loading, orderError = ref9.error;
    var handleResetValues = function(type) {
        switch(type){
            case "ticket":
                setTicketValues(INITIAL_TICKET_VALUES);
                setTicketResult(INITIAL_TICKET_STATE);
                break;
            case "order":
                setOrderValues(INITIAL_ORDER_VALUES);
                setOrderResult(INITIAL_ORDER_STATE);
                break;
            default:
                return;
        }
    };
    var handleDispatchInvoiceModal = function(dataToInvoice, type) {
        var isPurchasedOffline = type && type === "offline";
        dispatch({
            type: CommerceProvider/* APP_STATE_TYPES.TOGGLE_MODAL */.ro.TOGGLE_MODAL,
            kind: CommerceProvider/* MODAL_KIND.REQUEST_INVOICE */.jk.REQUEST_INVOICE,
            open: true,
            props: {
                context: type,
                isLoggedIn: userIsLogged,
                order: !isPurchasedOffline ? dataToInvoice : null,
                orderNumber: !isPurchasedOffline ? dataToInvoice === null || dataToInvoice === void 0 ? void 0 : dataToInvoice.publicOrderId : null,
                ticketInfo: isPurchasedOffline ? dataToInvoice : null,
                resetValues: handleResetValues
            }
        });
    };
    var handleDispatchLogginModal = function(invoiceData, context) {
        return dispatch({
            type: CommerceProvider/* APP_STATE_TYPES.TOGGLE_MODAL */.ro.TOGGLE_MODAL,
            kind: CommerceProvider/* MODAL_KIND.LOGIN */.jk.LOGIN,
            open: true,
            props: {
                logginBeforeInvoice: true,
                redirectToLogin: function() {
                    return dispatch({
                        type: CommerceProvider/* APP_STATE_TYPES.TOGGLE_MODAL */.ro.TOGGLE_MODAL,
                        kind: CommerceProvider/* MODAL_KIND.LOGIN */.jk.LOGIN,
                        open: true
                    });
                },
                handleInvoiceAsGuest: function() {
                    return handleDispatchInvoiceModal(invoiceData, context);
                }
            }
        });
    };
    var handleConsultTicket = function(e) {
        if (!ticketValues) return setTicketResult({
            message: "Los campos son invalidos o se encuentran vac\xedos"
        });
        var posId = ticketValues.posId, storeId = ticketValues.storeId, ticketId = ticketValues.ticketId, ticketDate = ticketValues.ticketDate;
        var formatStoreId = Number(storeId);
        var formatTicketDate = (0,parseISO/* default */.Z)(ticketDate);
        var formatedDateToISO = (0,format/* default */.Z)(formatTicketDate, "yyyy-MM-dd");
        var invoiceData = {
            storeId: storeId,
            ticketId: ticketId,
            posId: posId,
            dateSale: formatedDateToISO
        };
        e.preventDefault();
        if (ticketResult && ticketResult.ticketFound && ticketResult.canRequest) {
            if (!userIsLogged) {
                handleDispatchLogginModal(invoiceData, "offline");
            } else {
                handleDispatchInvoiceModal(invoiceData, "offline");
            }
        } else {
            getTicket({
                variables: {
                    posId: posId,
                    storeId: String(formatStoreId),
                    ticketId: ticketId,
                    ticketDate: formatedDateToISO
                }
            }).then(function(res) {
                return res && res.data ? setTicketResult((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, get_default()(res, [
                    "data",
                    "t3bTicket"
                ])), {
                    isInitialState: false
                })) : function() {
                    setTicketResult({
                        error: ticketError,
                        ticketFound: false
                    });
                    (0,error/* trackError */.t)({
                        label: "Error getting information",
                        extras: {
                            variables: ticket,
                            error: ticketError.toString()
                        }
                    });
                };
            });
        }
    };
    var handleConsultOrder = function(e) {
        if (!orderValues) return setOrderResult({
            message: "Los campos son invalidos o se encuentran vac\xedos"
        });
        var publicId = orderValues.publicId, total = orderValues.total;
        e.preventDefault();
        var invoiceData = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, orderValues), {
            publicOrderId: publicId
        });
        if (orderResult && orderResult.found && orderResult.canRequest) {
            if (!userIsLogged) {
                handleDispatchLogginModal(invoiceData, "online");
            } else {
                handleDispatchInvoiceModal(invoiceData, "online");
            }
        } else {
            getOrder({
                variables: {
                    publicId: publicId,
                    total: Number(total)
                }
            }).then(function(res) {
                var ref;
                return res && res.data ? setOrderResult(res === null || res === void 0 ? void 0 : (ref = res.data) === null || ref === void 0 ? void 0 : ref.orderForInvoice) : function() {
                    setOrderResult({
                        error: orderError,
                        found: false
                    });
                    (0,error/* trackError */.t)({
                        label: "Error getting information",
                        extras: {
                            variables: order,
                            error: orderError.toString()
                        }
                    });
                };
            });
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(InvoiceRequest_InvoiceRequest, {
        isDesktop: !isMobile,
        isLoading: loadingTicket || loadingOrder,
        orderStatus: orderResult,
        orderValues: orderValues,
        setOrderValues: setOrderValues,
        ticketValues: ticketValues,
        setTicketValues: setTicketValues,
        ticketStatus: ticketResult,
        handleConsultTicket: handleConsultTicket,
        handleConsultOrder: handleConsultOrder,
        handleResetValues: handleResetValues
    });
};
/* harmony default export */ var invoice_InvoicePage = (InvoicePage);

// EXTERNAL MODULE: ./layouts/Page.layout.js + 2 modules
var Page_layout = __webpack_require__(2952);
;// CONCATENATED MODULE: ./pages/facturacion/index.js





var Invoices = function(param) {
    var staticContent = param.staticContent;
    var metaTags = {
        title: "Facturaci\xf3n",
        shouldIndex: false
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Page_layout/* default */.Z, {
        staticContent: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, staticContent), {
            metaTags: metaTags
        }),
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(invoice_InvoicePage, {})
    });
};
var __N_SSP = true;
/* harmony default export */ var facturacion = (Invoices);


/***/ }),

/***/ 21960:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(92228);
/* harmony import */ var _apollo_client__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(60138);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    query Me {\n        me {\n            rfcs {\n                id\n                rfc\n                businessName\n                taxZipCode\n                address {\n                    streetAddress1\n                    externalNumber\n                    postalCode\n                    cityArea\n                    city\n                    countryArea\n                    country {\n                        country\n                        code\n                    }\n                }\n            }\n            referralCode {\n                conditionMessage\n                code\n                discountType\n                referralDiscountMessage\n                referralProgramTitle\n                referredDiscountMessage\n            }\n            preferredContactChannelDisplay\n            preferredContactChannel\n        }\n    }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}

var ME_BASIC_QUERY = (0,_apollo_client__WEBPACK_IMPORTED_MODULE_1__/* .gql */ .Ps)(_templateObject());
/* harmony default export */ __webpack_exports__["Z"] = (ME_BASIC_QUERY);


/***/ }),

/***/ 20958:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* reexport */ Caption_Caption; }
});

// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/prop-types/index.js
var prop_types = __webpack_require__(13980);
// EXTERNAL MODULE: ../../node_modules/classnames/index.js
var classnames = __webpack_require__(72779);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
;// CONCATENATED MODULE: ../../packages/designkit/src/components/webkit/atoms/Caption/Caption.jsx




var Caption = function(param) {
    var className = param.className, classNameImg = param.classNameImg, icon = param.icon, iconAlt = param.iconAlt, children = param.children;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
        className: classnames_default()(className, "mb-0 flex items-center text-left text-caption"),
        children: [
            typeof icon === "string" ? /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                src: icon,
                alt: iconAlt,
                className: classnames_default()(classNameImg, "mr-1")
            }) : icon,
            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                children: children
            })
        ]
    });
};
Caption.propTypes = {
    className: prop_types.string,
    iconClassName: prop_types.string,
    classNameImg: prop_types.string,
    icon: prop_types.oneOfType([
        prop_types.string,
        prop_types.node
    ]),
    iconAlt: prop_types.string,
    children: prop_types.oneOfType([
        prop_types.string,
        prop_types.object
    ]).isRequired
};
Caption.defaultProps = {
    iconAlt: "info",
    classNameImg: "w-6 h-6"
};
/* harmony default export */ var Caption_Caption = (Caption);

;// CONCATENATED MODULE: ../../packages/designkit/src/components/webkit/atoms/Caption/index.js



/***/ }),

/***/ 61739:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ SwitchButton_SwitchButton; }
});

// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ../../node_modules/prop-types/index.js
var prop_types = __webpack_require__(13980);
// EXTERNAL MODULE: ../../node_modules/classnames/index.js
var classnames = __webpack_require__(72779);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ../../node_modules/@headlessui/react/dist/components/switch/switch.js + 1 modules
var switch_switch = __webpack_require__(15729);
;// CONCATENATED MODULE: ../../packages/designkit/src/components/webkit/atoms/SwitchButton/SwitchButton.jsx




var SwitchButton = function(param) {
    var className = param.className, onClick = param.onClick, enabled = param.enabled, labelOn = param.labelOn, labelOff = param.labelOff;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(switch_switch/* Switch */.r, {
        checked: enabled,
        onChange: onClick,
        className: classnames_default()(className, "w-full"),
        tabIndex: "-1",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "relative flex h-11 w-full rounded-xxl bg-switch-button p-1",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    className: classnames_default()("z-0 block h-full w-1/2 transform rounded-xxl bg-switch-button-toggle transition duration-300 ease-in-out", [
                        "".concat(enabled && "translate-x-full")
                    ])
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "absolute inset-0 flex h-full w-full items-center justify-center",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            className: classnames_default()("w-1/2 font-body", [
                                "".concat(enabled ? "font-body-regular text-ui-black" : "font-body-normal text-ui-white"), 
                            ]),
                            children: labelOn
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            className: classnames_default()("w-1/2 font-body", [
                                "".concat(enabled ? "font-body-normal text-ui-white" : "font-body-regular text-ui-black"), 
                            ]),
                            children: labelOff
                        })
                    ]
                })
            ]
        })
    });
};
SwitchButton.propTypes = {
    className: prop_types.string,
    enabled: prop_types.bool,
    onClick: prop_types.func
};
/* harmony default export */ var SwitchButton_SwitchButton = (SwitchButton);

;// CONCATENATED MODULE: ../../packages/designkit/src/components/webkit/atoms/SwitchButton/index.js



/***/ }),

/***/ 38534:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(70865);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(96670);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2784);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(13980);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(72779);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var reakit_Tooltip__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(97988);
/* harmony import */ var reakit_Tooltip__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(96247);
/* harmony import */ var reakit_Tooltip__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(63890);
/* harmony import */ var reakit_Tooltip__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(34301);







var Tooltip = function(param) {
    var uniqueId = param.uniqueId, anchorClassName = param.anchorClassName, tooltipBgColor = param.tooltipBgColor, arrowFillColor = param.arrowFillColor, placement = param.placement, showOnHover = param.showOnHover, tooltipContent = param.tooltipContent, children = param.children;
    // Prefix is required to target tooltip with CSS selector (see tailwind.scss)
    var id = "aria-tooltip-" + uniqueId;
    var tooltipState = (0,reakit_Tooltip__WEBPACK_IMPORTED_MODULE_3__/* .useTooltipState */ .K)({
        baseId: id,
        padding: 5,
        gutter: 12,
        visible: showOnHover ? undefined : true,
        placement: placement,
        unstable_fixed: true,
        unstable_flip: true
    });
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        tooltipState.place(placement);
    }, [
        tooltipState.place,
        placement
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(reakit_Tooltip__WEBPACK_IMPORTED_MODULE_4__/* .TooltipReference */ .v, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({}, tooltipState), {
                as: "div",
                className: classnames__WEBPACK_IMPORTED_MODULE_2___default()(anchorClassName, {
                    "cursor-pointer": showOnHover
                }),
                children: children
            })),
            tooltipContent && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(reakit_Tooltip__WEBPACK_IMPORTED_MODULE_7__/* .Tooltip */ .u, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({
                baseId: id
            }, tooltipState), {
                visible: showOnHover ? tooltipState.visible : true,
                unstable_portal: false,
                className: classnames__WEBPACK_IMPORTED_MODULE_2___default()(tooltipBgColor, "max-w-sm rounded-sm p-2 text-center text-ui-black", placement === "top" ? "shadow-up" : "shadow-down"),
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(reakit_Tooltip__WEBPACK_IMPORTED_MODULE_8__/* .TooltipArrow */ .C, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({}, tooltipState), {
                        className: classnames__WEBPACK_IMPORTED_MODULE_2___default()("h-6 w-6", arrowFillColor)
                    })),
                    typeof tooltipContent === "string" ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                        className: "mb-0",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("small", {
                            children: tooltipContent
                        })
                    }) : tooltipContent
                ]
            }))
        ]
    });
};
Tooltip.displayName = "Tooltip";
Tooltip.defaultProps = {
    tooltipBgColor: "bg-brand-primary-300",
    arrowFillColor: "fill-brand-primary-300",
    placement: "auto",
    showOnHover: true
};
Tooltip.propTypes = {
    uniqueId: prop_types__WEBPACK_IMPORTED_MODULE_9__.string.isRequired,
    anchorClassName: prop_types__WEBPACK_IMPORTED_MODULE_9__.string,
    tooltipClassName: prop_types__WEBPACK_IMPORTED_MODULE_9__.string,
    tooltipBgColor: prop_types__WEBPACK_IMPORTED_MODULE_9__.string,
    arrowFillColor: prop_types__WEBPACK_IMPORTED_MODULE_9__.string,
    placement: prop_types__WEBPACK_IMPORTED_MODULE_9__.oneOf([
        "auto-start",
        "auto",
        "auto-end",
        "top",
        "bottom",
        "left",
        "right", 
    ]),
    showOnHover: prop_types__WEBPACK_IMPORTED_MODULE_9__.bool,
    /** Text to show inside the tooltip */ tooltipContent: prop_types__WEBPACK_IMPORTED_MODULE_9__.oneOfType([
        prop_types__WEBPACK_IMPORTED_MODULE_9__.string,
        prop_types__WEBPACK_IMPORTED_MODULE_9__.node
    ]),
    /** Tooltip width */ children: prop_types__WEBPACK_IMPORTED_MODULE_9__.node
};
/* harmony default export */ __webpack_exports__["Z"] = (Tooltip);


/***/ }),

/***/ 12965:
/***/ (function(module) {

module.exports = "/_next/static/images/invoice-order-tooltip-9a3d1169c5584469de11113f187fc529.svg";

/***/ }),

/***/ 64246:
/***/ (function(module) {

module.exports = "/_next/static/images/invoice-ticket-tooltip-b6d76e30c2855f6103404a2d7e5f228c.svg";

/***/ }),

/***/ 5519:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2784);

function BillNoteIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "M13.633 2c1.174.907 2.122 2.041 3.189 3.069.72.694 1.628 1.28 2.028 2.175.4.893.133 1.96.133 2.962.014 3.375-.013 6.75.014 10.126.013.8-.227 1.361-.974 1.681H4.96c-.747-.32-.974-.894-.974-1.694.04-5.51.04-11.02.013-16.531 0-.774.187-1.361.84-1.788h8.793zM4.841 12.047c0 2.802.013 5.59-.014 8.392 0 .534.134.747.707.747 3.976-.013 7.939-.013 11.915 0 .507 0 .72-.147.72-.68-.013-4.07-.013-8.126 0-12.195 0-.374-.093-.494-.466-.48-.974.026-1.948.013-2.936.013-1.147-.013-1.6-.467-1.6-1.628-.014-.934-.04-1.868.013-2.802.026-.507-.16-.613-.64-.6-2.282.027-4.577.027-6.859 0-.627-.013-.867.187-.854.84.027 2.802.014 5.604.014 8.393zm9.166-8.54v3.03c0 .253.093.453.373.453 1.014.013 2.028 0 3.029 0-1.12-1.16-2.215-2.268-3.402-3.482z"
  }), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "M8.937 7.003c-.267 0-.534-.013-.788 0-.333.027-.587.147-.667.534-.08.387.04.654.4.814.534.227 1.068.413 1.602.654.76.333 1.134.893 1.067 1.587-.08.747-.507 1.228-1.227 1.374-.307.067-.334.214-.32.454.013.267-.134.414-.4.414-.281 0-.428-.16-.401-.414.053-.48-.254-.4-.534-.4-.293-.013-.68.093-.694-.387-.013-.547.4-.414.708-.427.4-.013.8 0 1.2 0 .414 0 .747-.12.854-.574.107-.467-.173-.694-.547-.854-.507-.2-1.04-.387-1.534-.613-.694-.32-1.054-.894-.987-1.575.066-.72.466-1.187 1.187-1.334.267-.053.374-.173.347-.44-.013-.254.107-.44.373-.454.307-.013.454.147.44.454-.026.573.401.32.655.36.213.04.453 0 .56.253.067.16.053.32-.04.44-.134.188-.36.148-.547.148-.267-.014-.48-.014-.707-.014zM11.538 16.156H7.282c-.293 0-.68.08-.694-.387-.013-.453.334-.44.667-.44h8.58c.333 0 .667 0 .667.44-.014.467-.4.387-.694.387h-4.27zM11.539 18.678H7.282c-.307 0-.667.08-.693-.387-.027-.467.346-.427.653-.427h8.58c.306 0 .666-.053.653.427-.013.48-.387.4-.68.4-1.428-.013-2.842-.013-4.256-.013zM14.047 12.82h1.921c.307 0 .534.12.52.454 0 .307-.226.4-.493.414h-3.99c-.266 0-.493-.094-.493-.414 0-.347.24-.44.534-.44.667-.014 1.334-.014 2-.014zM14.834 11.192h-1.188c-.293 0-.466-.146-.466-.44 0-.293.186-.427.466-.427h2.375c.28 0 .48.12.48.427 0 .294-.186.427-.48.427-.4.013-.787.013-1.187.013z"
  }));
}
const ForwardRef = react__WEBPACK_IMPORTED_MODULE_0__.forwardRef(BillNoteIcon);
/* harmony default export */ __webpack_exports__["Z"] = (ForwardRef);

/***/ }),

/***/ 14718:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2784);

function CheckIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "M8.25 21a.375.375 0 01-.265-.11L3.11 16.015a.375.375 0 01.53-.53l4.563 4.562L20.32 3.156a.378.378 0 01.523-.086.372.372 0 01.152.244.372.372 0 01-.065.28L8.554 20.844A.376.376 0 018.28 21h-.03z"
  }));
}
const ForwardRef = react__WEBPACK_IMPORTED_MODULE_0__.forwardRef(CheckIcon);
/* harmony default export */ __webpack_exports__["Z"] = (ForwardRef);

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [1607,2547,8104,2952,7529,9774,2888,179], function() { return __webpack_exec__(81445); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);